export default __webpack_public_path__ + "static/media/aww-yeah-sax.dbf6e803.gif";